import React from 'react'
import propTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'
import { FaClock } from 'react-icons/fa'
import { useClient } from 'jsonapi-react'

import Button from 'components/Button'
import Dropdown from 'components/Dropdown'


export default function Event(props) {
  const [showFullDescription, setShowFullDescription] = React.useState(false)
  const client = useClient()

  const actionButtons = []

  const deleteEvent = (id) => {
    client.delete(['events', id])
  }

  if (props.permissions?.delete) {
    actionButtons.push(
      {
        'label': 'Delete',
        'onClick': (e) => {
          e.preventDefault()
          e.stopPropagation()
          deleteEvent(props.id)
        }
      }
    )
  }

  if (props.permissions?.edit && false) {
    actionButtons.push(
      {
        'label': 'Edit',
        'onClick': (e) => {
          e.preventDefault()
          e.stopPropagation()
          deleteEvent(props.id)
        }
      }
    )
  }

  return (
    <div className={classNames([
      'relative flex flex-col sm:flex-row mb-5 bg-white transition-all',
      'hover:shadow-md',
      props.className,
    ])}>
      <img
        className='sm:flex-1 object-cover w-full h-60 sm:h-auto flex-grow-0'
        alt={props.title}
        src={props.image?.small}
      />
      <div className='p-5 flex flex-col flex-grow'>
        <div className='flex space-x-2 items-start mb-2'>
          <div className='text-lg font-bold flex-grow flex-1'>
            {props.title}
          </div>
          <div className='text-sm mt-1 text-disabled-400 flex flex-grow-0 flex-1 space-x-1 items-center'>
            <FaClock />
            <div className='flex flex-col'>

              <div className='space-x-1'>
                <span>{moment(props.startDatetime).format('DD/MM')}</span>
                <span>{moment(props.startDatetime).format('HH:mm')}</span>
              </div>
              {
                props.endDatetime &&
                <div className='space-x-1'>
                  <span>{moment(props.endDatetime).format('DD/MM')}</span>
                  <span>{moment(props.endDatetime).format('HH:mm')}</span>
                </div>
              }
            </div>
          </div>
        </div>
        <div className='text-sm flex-grow text-disabled-700'>
          {
            props.description.length > 200 ?
              showFullDescription ?
              [
                props.description,
                <br/>,
                <Button onClick={() => setShowFullDescription(false)}>see less</Button>
              ] :
              [
                props.description.substr(0, 200),
                '...',
                <br/>,
                <Button onClick={() => setShowFullDescription(true)}>see more</Button>
              ]
            : props.description
          }
        </div>
        {
          actionButtons.length > 0 &&
          <Dropdown
            className='text-right'
            itemClassName='bottom-full right-0'
            items={actionButtons}
          />
        }
      </div>
    </div>
  )
}

Event.propTypes = {
  className: propTypes.string,
  image: propTypes.string.isRequired,
  startDatetime: propTypes.instanceOf(Date).isRequired,
  endDatetime: propTypes.instanceOf(Date),
  title: propTypes.string.isRequired,
  description: propTypes.string,
  createdBy: propTypes.object.isRequired,
  permissions: propTypes.object,
}
